import { JSX } from 'react';
import { SkeletonPulse, VideoSkeleton } from '@bg-components/Skeleton';
import classes from './VideoArchiveSkeleton.module.scss';

export const VideoArchiveSkeleton = (): JSX.Element => (
    <section className={classes.container}>
        <div className={classes.head}>
            <SkeletonPulse width="70px" height="26px" radius="15px" className={classes.back} />
            <SkeletonPulse width="120px" height="26px" radius="15px" />
        </div>
        <VideoSkeleton />
        <SkeletonPulse width="150px" height="30px" radius="15px" className={classes.results} />
        <SkeletonPulse width="120px" height="20px" radius="15px" />
    </section>
);
